<template>
	<div id="guide_active">

		<b-modal id="modal_guide_active" class="bg-color-light" size="lg" scrollable centered hide-header hide-footer @hidden="handleCloseModal">
			<div class="guide-active">
				<a href="javascript:;" class="guide-active__close four-color" @click="handleCloseModal"><i class="fas fa-times-circle"></i></a>
				<b-tabs class="register-page__tabs">
			        <b-tab v-if="dataGuide.activeIntro">
			            <template v-slot:title>Giới thiệu mã kích hoạt</template>
			            <div class="guide-active__content primary-color-txt font-sanpro-light" v-html="dataGuide.activeIntro"></div>
			        </b-tab>
			        <b-tab v-if="dataGuide.activeGuide">
			            <template v-slot:title>Hướng dẫn sử dụng mã kích hoạt</template>
			            <div class="guide-active__content  primary-color-txt font-sanpro-light" v-html="dataGuide.activeGuide"></div>
			        </b-tab>
					<b-tab v-if="dataGuide.activeNoti ">
			            <template v-slot:title>Liên hệ</template>
			            <div class="guide-active__content  primary-color-txt font-sanpro-light" v-html="dataGuide.activeNoti "></div>
			        </b-tab>
			    </b-tabs>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { getGuideActiveCode } from '@/store/common/api'
	import { getAuth } from '@/utils/jwt'

	export default {
		name: 'ModalGuideActiveCode',
		data () {
			return {
				dataGuide: {
					activeIntro: "Gioi thieu ma kich hoat",
        			activeGuide: "Huong dan su dung ma kich hoat"
				}
			}
		},
		computed: {
			...mapState('common', ['isShowGuideActiveBook']),
		},
		watch: {
			isShowGuideActiveBook(newVal) {
				this.getGuideContent();
				if(newVal) {
					this.$bvModal.show('modal_guide_active')
				} else {
					this.$bvModal.hide('modal_guide_active');
				}
			}
		},
		created() {
			this.getGuideContent();
		},
		methods: {
			...mapActions('common', ['setToggleGuideActiveBook']),

			getGuideContent() {
				let self = this;
				getGuideActiveCode().then(res => {
						if(res && res.data && !res.errors) {
							self.dataGuide = res.data;
						}
					})
			},

			handleCloseModal() {
				this.setToggleGuideActiveBook(false);
			}
		}
	}
</script>

<style lang="scss">
	#modal_guide_active {
		.modal-content {
			border: 0;
		}
		.modal-content, .modal-body {
			border-radius: 15px;
		}

		.modal-body {
			background: #fff;
			padding: 20px 25px;
		}

		.guide-active {
			&__content {
				padding: 30px 0;
			}

			&__close {
				position: absolute;
				top: 10px;
				right: 10px;
			}
		}
	}
</style>